import { api } from '@/apis';
import { encodeParams } from '@/utils';
import { useQuery } from '@tanstack/react-query';

export function useOptionValues(name) {
  return useQuery({
    queryKey: ['options', name, 'values'],
    queryFn: async () => {
      const searchParams = encodeParams({
        query: { name },
        projection: { value: true, label: true, values: true },
      });
      const options = await api.get('options', { searchParams }).json();

      return options.reduce((accumulator, { value, label, values }) => {
        accumulator[value] = { label, values };

        return accumulator;
      }, {});
    },
    placeholderData: {},
    staleTime: 60 * 60 * 1000,
  });
}
